const getClassesByEP = (classes, ep) => {
  const _ep = Number.parseInt(ep, 10);
  return (classes || []).filter(
    ({ educationPeriod }) => educationPeriod === _ep,
  );
};

export default getClassesByEP;
